import { Logger } from "./logger";
import { exec } from 'child_process';
import fs from 'fs';

/**
 * the run command function.
 * @param cmd the command to run.
 * @param debug the debug flag.
 * @param forceDebug the force debug flag.
 * @param finalizeInfo the finalize info.
 * @param writeToFileName the write to file name.
 * @returns
 */
export function runCommand(cmd: string, debug = false, forceDebug = false, finalizeInfo = undefined, writeToFileName?: string): Promise<string> {
    const loggerPrefix = `runCommand - ${cmd}`;
    const loggerErrorPrefix = `error - runCommand - ${cmd}`;
    let logString = '';

    console.log(`Running ${cmd}`);
    return new Promise((resolve) => {
        const child = exec(cmd, (error, stdout, stderr) => {
            if (error) {
                Logger.error(`  exec error: ${error}`);
                resolve(logString);
                return;
            }

            stdout.split('\n').filter(line => line.trimEnd()).forEach(
                line => {
                    logString += `${replaceANSIEscape(line)}\n`;
                    Logger.log(line, loggerPrefix);
                }
            );
            stderr.split('\n').filter(line => line.trimEnd()).forEach(
                line => {
                    logString += `${replaceANSIEscape(line)}\n`;
                    Logger.error(line, loggerErrorPrefix)
                }
            );

            resolve(logString);
        });

        if (debug || forceDebug) {
            child.stdout.on('data', (data) => {
                data.split('\n').filter(line => line.trimEnd()).forEach(
                    line => {
                        logString += `${replaceANSIEscape(line)}\n`;
                        Logger.log(`  ${line}`, loggerPrefix)
                    }
                );
            });
        }

        child.stderr.on('data', (data) => {
            data.split('\n').filter(line => line.trimEnd()).forEach(
                line => {
                    logString += `  ${replaceANSIEscape(line)}\n`;
                    Logger.error(`  ${line}`, loggerErrorPrefix)
                }
            );
        });

        child.on('close', (code) => {
            logString += `exitCode: ${code}\n`;
            Logger.log(`exitCode: ${code}`);
            if (code !== 0 && finalizeInfo) {
                logString += `${finalizeInfo}\n`;
                Logger.log(finalizeInfo);
            }

            if (writeToFileName) {
                fs.writeFile(writeToFileName, logString, (writeErr) => {
                    if (writeErr) {
                        Logger.error(`Error writing log to file: ${writeErr}`);
                    } else {
                        console.log(`Logs saved to log'`);
                    }
                });
            }
        });
    });
}

function replaceANSIEscape(line: string) {
    return line.replace(/\x1B\[[0-9;]*[JKmsu]/g, '');
}
